import { useTheme } from '@mui/system';
import { colors } from 'src/styles/theme';

/**
 * usePrimaryButtonStyle is a hook that returns an object with styles for a primary button.
 *
 * @returns {Object} - An object with styles for a primary button.
 */
const usePrimaryButtonStyle = () => {
  const theme = useTheme();
  return {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
      color: theme.palette.primary.main,
    },
    '&:disabled': {
      backgroundColor: colors.backdrop.disabled,
      color: 'white',
    },
  };
};

export default usePrimaryButtonStyle;
